module.exports = __webpack_public_path__ + "31139ee3ae5fadbabb733bae9d30138d.svg";